import Model from '../../models/model';


const model = new Model({
	name: 'Login',
	action: 'changepassword',
	combos: [],
	columns: [
		{
			field: 'OldPassword',
			header: 'CurrentPassword',
			type: 'password',
			skipPasswordStrengthCheck: true,
			required: true,
			inlineLabelSize: 12
		},
		{
			field: 'NewPassword',
			header: 'NewPassword',
			type: 'password',
			required: true,
			inlineLabelSize: 12
		},
		{
			field: 'ConfirmPassword',
			header: 'ConfirmPassword',
			type: 'password',
			validate: 'compare:NewPassword',
			required: true,
			inlineLabelSize: 12
		}
	]
});

export default model.createFormDialog();
